// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"3a96c420","312":"b62f07c9","453":"698788f4","457":"a5c16e91","551":"b35941c5"}[chunkId] + ".chunk.js";
};